import React, {Component} from "react";
import SimilarCharacteristics from "./SimilarCharacteristics";

export default class SimilarCategories extends Component {
    render() {
        return (<SimilarCharacteristics showCategory={true} {...this.props} />);
    }
}
